import {
    ModalV2,
    ModalV2Title,
    ModalV2Content,
    ModalV2Footer,
    ButtonGroup,
    Button,
} from '@design-system-etat/dsfr-react';
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './ModalePerteVol.module.scss';

const ModalePerteVol = ({ fermerModale, etape2PerteVol }) => {
    const { REACT_APP_CONTACT_GENDARMERIE_POLICE_URL } = process.env;

    const dialog = useRef();

    useEffect(() => {
        if (dialog.current) {
            dialog.current.showModal();
        }
    }, [dialog]);

    return (
        <>
            <ModalV2
                id="signalerPerteVol"
                idModalTitle="signalerPerteVol-title"
                size="lg"
                onClose={fermerModale}
                ref={dialog}
            >
                <ModalV2Content>
                    <ModalV2Title id="signalerPerteVol-title">
                        Signaler la perte ou le vol d'une arme :
                    </ModalV2Title>

                    <p className={styles.modalePerteVol__description}>
                        Si vous avez perdu ou que vous vous êtes fait voler une arme ou un élément
                        d&apos;arme des catégories A, B, ou C vous devez immédiatement faire une
                        déclaration au commissariat de police ou à la brigade de gendarmerie.
                    </p>
                    <p className={styles.modalePerteVol__texteGras}>Où s&apos;adresser ?</p>
                    <a
                        title="Ministère de l'intérieur - Contact Gendarmerie Police"
                        href={REACT_APP_CONTACT_GENDARMERIE_POLICE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Contacter une brigade de gendarmerie ou un commissariat de police
                    </a>
                    <p className={styles.modalePerteVol__avertissement}>
                        Pour signaler la perte ou le vol d&apos;une arme sur votre espace
                        détenteurs, vous devez importer le récépissé de déclaration de perte ou de
                        été remis par les services de police ou de gendarmerie
                    </p>
                </ModalV2Content>
                <ModalV2Footer>
                    <ButtonGroup align="right" inline>
                        <Button onClick={fermerModale}>Annuler</Button>
                        <Button name="Continuer" variant="primary" onClick={etape2PerteVol}>
                            Continuer
                        </Button>
                    </ButtonGroup>
                </ModalV2Footer>
            </ModalV2>
        </>
    );
};

ModalePerteVol.propTypes = {
    fermerModale: PropTypes.func.isRequired,
    etape2PerteVol: PropTypes.func.isRequired,
};

export default ModalePerteVol;
